import { useAppStateContext } from '~components/providers/AppStateProvider';

export const useIsClient = () => {
  const { isClient } = useAppStateContext();

  return isClient;
};
